import { watchSetAttendance, setAttendance } from './sagas/setAttendance.saga';
import { watchInitializeApp, initializeApp } from './sagas/initializeApp.saga';

export const watcherSagas = {
  watchSetAttendance,
  watchInitializeApp,
};

export const sagas = {
  setAttendance,
  initializeApp,
};
